<template lang="pug">
//- Route mapping only
</template>

<script>
/* eslint no-multi-spaces: 0 */
/* eslint key-spacing    : 0 */

import tabs from '@/core/site-map/map.json'
import User from '@/core/user'
import LegacyAuth from '@/core/legacy-auth'
// import { EventBus } from '@/event-bus'

import Intercom from '@/components/intercom'
import Salesforce from '@/components/salesforce'

const { allowedModules } = LegacyAuth

export default {
  created() {
    this.$route.query.ReturnUrl || this.polyfillParent()

    if (User.get() && !this.$route.query.ReturnUrl) {
      this.findPath()
    } else {
      this.gotoLogin()
    }
  },

  methods: {
    /**
     * Provide legacy utility functions to global namespace
     *
     */
    polyfillParent() {
      /* this.$nextTick(() => {
        let updateHashCopy = this.updateHash
        if (this.updateHash) {
          this.updateHash = function () {
            EventBus.$emit('navigated', global.frames['NetFrame'].location.href)
            updateHashCopy()
          }
          this.$forceUpdate()
        }
      }) */

      const vm = this
      if (User.get()) {
        // Page
        global.Page = {
          BankAccount       : User.get().hasBankAccount,
          VendorType        : User.get().subscription,
          InvoicePrefHidden : User.get().invoicePrefHidden,
          MarketTypeHidden  : { value: User.get().domain },
          // TODO:
          // check if always 1
          IsCompany         : { value: 1 },

          navigateToPage: function (page, keepParams) {
            //
            // console.info('legacy navigateToPage called')
            global.frames['NetFrame'].location.href = `${global.app.api.env}/${page}`
          },

          showTabs: function (section, tab, param, force) {
            //
            // console.info((tab || section) ? `legacy showTabs called with ${section} ${tab}` : 'cleared legacy tabs')

            // go to Dashboard
            if (section === 'HomeEO') {
              vm.$router.push('/home')
            }

            if (section === 'Commerce' || section === 'Sourcing') {
              // vm.$router.push({ params: { action: '--' } })
            }

            // go to Programs subtab if called with only 'Commerce' section
            if (section === 'Commerce' && !tab && !param) {
              vm.$router.push({ params: { action: '--' } })
              vm.$root.legacyTab = 'Commerce'
              vm.$root.legacySubtab = 'Programs'
              return
            }
            // go to Programs subtab if called with only 'Invoices' section
            if (section === 'Invoices' && !tab && !param) {
              vm.$router.push({ params: { action: '--' } })
              vm.$root.legacyTab = 'Invoices'
              vm.$root.legacySubtab = 'Invoices'
              return
            }

            // php redirects
            if (tab && ~tab.indexOf('common.')) {
              tab = tab.replace('common.', '../?page=common.')
              vm.$router.push({ params: { action: '--' } })
            } else {
              // FIXME:
              // added param to be able to navigate back
              if (tab && !param && force !== null) {
                vm.$router.push({ params: { action: '__' } })
              }
            }

            //
            if (global.frames['NetFrame'] && tab && !param && force !== null) {
              global.frames['NetFrame'].location.href = `${global.app.api.env}/${tab}`
            }

            if (param && section && force !== null) {
              vm.$router.push(`/i/${section}/?goto=${param}&noRedir=1`)
            }

            // map back legacy php
            if (tab) {
              tab = tab.replace('../?page=', '')
            }

            // make tabs/subtabs active
            vm.$root.legacyTab = section
            vm.$root.legacySubtab = tab
          }
        }

        Intercom.setup()
      }

      global.showOverlay = function () {
        document.body.setAttribute('legacy-modal', true)
        document.querySelector('.dawn-title-nav.sticky') && document.querySelector('.dawn-title-nav.sticky').classList.remove('sticky')
      }

      global.hideOverlay = function () {
        document.body.setAttribute('legacy-modal', false)
      }

      // legacy sticky sidebar
      function stickyScrollHandler ($) {
        window.topNavHeight = 145
        var viewport = document.querySelector('.main-panel')

        viewport && viewport.addEventListener('scroll', function (e) {
          if (!$('body').hasClass('pp-sticky-listen') || document.documentMode) {
            return
          }

          var $sidebar = $('#iframe iframe').contents().find('.sticky[id]:visible')
          _stick2($sidebar, viewport.scrollTop)
          _resize($sidebar, viewport.scrollTop, -70)
        })

        function _stick2 ($el, pos) {
          var topOffset = pos > window.topNavHeight ? pos - window.topNavHeight : 0

          if (topOffset) {
            $el.addClass('floated')
            $('#content').addClass('fixed-bar')
          } else {
            $el.removeClass('floated')
            $('#content').removeClass('fixed-bar')
          }

          $el.css({
            transform: 'translateY(' + topOffset + 'px)'
          })
        }

        function _resize ($el, pos, offset, $list) {
          var topOffset = offset || 0

          if (typeof $list !== 'undefined') {
            $list.css('min-height', $el.height() + 100)
          }

          $el.css({
            height: window.innerHeight - (pos > window.topNavHeight ? topOffset + 70 : window.topNavHeight - pos)
          })
        }
      }

      global.jQuery(function () {
        stickyScrollHandler(global.jQuery)
      })

      Intercom.init()
      Salesforce.init()
    },

    /**
     * Handle legacy links
     * Route to corresponding module based on query string parameters
     *
     * @summary Redirect legacy links
     */
    findPath() {
      allowedModules.get || allowedModules()

      const route   = this.$route.query
      const tab     = route.goToPage
      let subtab  = route.tab
      let page    = route.param || route.id

      if (subtab && subtab.indexOf('_') > -1) {
        if (User.get().domain === '1') {
          page = page.split('_')[1]
          subtab = subtab.split('_')[1]
        } else {
          page = page.split('_')[0]
          subtab = subtab.split('_')[0]
        }
      }

      if (tab === 'app') {
        this.$router.push(subtab)
        return
      }

      // TODO:
      // this should use original query params (ie. goToPage
      const pageToLoadFromReport = route.pageToLoadFromReport

      if (pageToLoadFromReport) {
        global.Page.showTabs('Programs', pageToLoadFromReport.split('__')[0], pageToLoadFromReport.split('__')[1])
        return
      }

      const tabsMap = Object.keys(allowedModules.get)

      let maintab   = tabsMap.filter(k => allowedModules.get[k].label === tab)[0]
      let section   = tabs[maintab] && tabs[maintab].pack && (tabs[maintab].pack[subtab] || tabs[maintab].pack['#' + subtab]).name

      if (!(tabs[maintab] && tabs[maintab].pack)) section = subtab

      if (page && maintab || section) {
        let prettyPage = page ? page.replace(/\//g, '--') : section

        this.$router.push({ name: '_allModules', params: { namespace: 'i', page: maintab, section: prettyPage } })
        return
      }

      if (tab === 'undefined') {
        this.$router.push('/home')
        return
      }

      if (maintab) {
        console.log('About to go to', maintab, section)
        this.$router.push({ name: '_allModules', params: { namespace: 'd', page: maintab, section } })
      } else {
        this.$router.push('/home')
      }
    },

    /**
     * Handle external login links
     * If user is not present, redirect to login module
     * with all necessary query string parameters
     *
     * @summary Login from e-mails
     */
    gotoLogin() {
      const route  = this.$route.query
      const tab    = route.goToPage || '0'
      const subtab = route.tab || '0'
      const page   = route.param
      const sk     = route.sk || ''
      const redir  = route.redirectUrl
      const Redir  = route.ReturnUrl

      if (redir) {
        global.location.href = `${this.api.env}/${redir}`
        return
      }
      if (Redir) {
        if (global.parent.app.$router) {
          global.parent.app.$user.logout(true)
          global.parent.app.$router.push({ name: 'login', query: { returnUrl: `${global.parent.location.href}`, noRedir: '1' } })
        } else {
          this.$router.push({ name: 'login', query: { returnUrl: `${this.api.env}/..${Redir}`, noRedir: '1' } })
        }
        return
      }
      let prettyPage = page ? page.replace(/\//g, '--') : ''
      this.$router.push({ name: 'login', query: { returnUrl: this.getReturnUrl(tab, subtab, prettyPage), sk, noRedir: '1' } })
    },

    getReturnUrl(tab, subtab, prettyPage) {
      if (tab === 'app') {
        return subtab
      } else {
        return `${tab}__${subtab}__${prettyPage}`
      }
    }
  }
}

</script>



// WEBPACK FOOTER //
// src/components/LegacyContainer/legacyRouter.vue